import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-auto py-4 border-top" data-bs-theme="dark">
      <Container>
        <Row className="align-items-center">
          <Col md={6} className="text-center text-md-start">
            <p className="mb-0 text-muted">
              © {currentYear} Social Value. Alle Rechte vorbehalten.
            </p>
          </Col>
          <Col md={6} className="text-center text-md-end">
            <p className="mb-0 text-muted">
              Gebaut mit <i className="fas fa-heart text-danger"></i> für KI-Enthusiasten
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
